(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_quantity-breaks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-breaks')) {
    customElements.define(
      'quantity-breaks',
      class QuantityBreaks extends HTMLElement {
        /*
         * Shared document/window swatch-dropdown listeners: attached once for all instances
         * (not N times). Each handler still runs on every connected instance, which filters
         * by ownership internally exactly as before.
         */
        static swatchListenerCount = 0;

        static dispatchSwatchHandler(method, event) {
          document.querySelectorAll('quantity-breaks').forEach((el) => {
            if (typeof el[method] === 'function') el[method](event);
          });
        }

        static onDocClick = (event) => QuantityBreaks.dispatchSwatchHandler('handleSwatchSelectClick', event);
        static onDocKeydown = (event) => QuantityBreaks.dispatchSwatchHandler('handleSwatchSelectKeydown', event);
        static onDocPointerDown = (event) => QuantityBreaks.dispatchSwatchHandler('handleSwatchSelectOutside', event);
        static onWindowResize = (event) => QuantityBreaks.dispatchSwatchHandler('handleSwatchSelectReposition', event);
        static onWindowScroll = (event) => QuantityBreaks.dispatchSwatchHandler('handleSwatchSelectReposition', event);

        connectedCallback() {
          this.handleChange = this.handleChange.bind(this);
          this.handlePickerPointerDown = this.handlePickerPointerDown.bind(this);
          this.handleQuantityUpdate = this.handleQuantityUpdate.bind(this);
          this.handleProductSelect = this.handleProductSelect.bind(this);
          this.handleSwatchSelectClick = this.handleSwatchSelectClick.bind(this);
          this.handleSwatchSelectOutside = this.handleSwatchSelectOutside.bind(this);
          this.handleSwatchSelectKeydown = this.handleSwatchSelectKeydown.bind(this);
          this.handleSwatchSelectReposition = this.handleSwatchSelectReposition.bind(this);
          this.variantUpdateGeneration = 0;
          this.variantUpdateController = null;
          this.addEventListener('change', this.handleChange);
          this.addEventListener('pointerdown', this.handlePickerPointerDown);
          if (QuantityBreaks.swatchListenerCount === 0) {
            document.addEventListener('click', QuantityBreaks.onDocClick);
            document.addEventListener('keydown', QuantityBreaks.onDocKeydown);
            document.addEventListener('pointerdown', QuantityBreaks.onDocPointerDown);
            window.addEventListener('resize', QuantityBreaks.onWindowResize);
            window.addEventListener('scroll', QuantityBreaks.onWindowScroll, true);
          }
          QuantityBreaks.swatchListenerCount += 1;
          this.scope = this.closest('.product-information') || document;
          this.scope.addEventListener('quantity-selector:update', this.handleQuantityUpdate);
          this.productSelectTarget = this.closest('.shopify-section, dialog');
          this.productSelectTarget?.addEventListener('shopify:product:select', this.handleProductSelect);
          this.unifyRadios();
          this.groupWithSiblings();
          this.relocateUnlocks();
          this.syncColumnCount();
          // CE owns boot (inline script removed). SSR already marks the default option checked.
          // Re-run after layout in case children upgrade late in the theme editor.
          this.initializeSelection();
          requestAnimationFrame(() => {
            this.relocateUnlocks();
            this.initializeSelection();
            this.syncOptionPrices();
            this.syncProductUnlocks();
            this.repairCollapsedOptions();
          });
        }

        disconnectedCallback() {
          this.closeAllSwatchSelects();
          this.removeEventListener('change', this.handleChange);
          this.removeEventListener('pointerdown', this.handlePickerPointerDown);
          QuantityBreaks.swatchListenerCount = Math.max(0, QuantityBreaks.swatchListenerCount - 1);
          if (QuantityBreaks.swatchListenerCount === 0) {
            document.removeEventListener('click', QuantityBreaks.onDocClick);
            document.removeEventListener('keydown', QuantityBreaks.onDocKeydown);
            document.removeEventListener('pointerdown', QuantityBreaks.onDocPointerDown);
            window.removeEventListener('resize', QuantityBreaks.onWindowResize);
            window.removeEventListener('scroll', QuantityBreaks.onWindowScroll, true);
          }
          if (this.scope) this.scope.removeEventListener('quantity-selector:update', this.handleQuantityUpdate);
          this.productSelectTarget?.removeEventListener('shopify:product:select', this.handleProductSelect);
          this.variantUpdateController?.abort();
          clearTimeout(this._editorRemountTimer);
          clearTimeout(this._editorRemountTimerLate);
        }

        getQuantityComponent() {
          return this.scope.querySelector('product-form-component quantity-selector-component');
        }

        getGroupScope() {
          if (!this.classList.contains('quantity-breaks--grouped')) return this;
          const list = this.closest('.quantity-breaks-list');
          if (list) return list;
          const host = this.closest('.shopify-block') || this;
          return host.parentElement || this;
        }

        relocateUnlocks() {
          const grid = this.querySelector('.quantity-breaks__grid');
          const fieldset = this.querySelector('.quantity-breaks__fieldset');
          if (!(grid instanceof HTMLElement) || !(fieldset instanceof HTMLElement)) return;

          const unlockNodes = Array.from(grid.children).filter((child) => {
            if (!(child instanceof HTMLElement)) return false;
            // Never move option cards — only unlock wrappers.
            if (child.querySelector('.quantity-breaks__option')) return false;
            return (
              child.matches('[data-quantity-breaks-unlocks]') ||
              Boolean(child.querySelector('[data-quantity-breaks-unlocks]'))
            );
          });

          unlockNodes.forEach((node) => {
            if (node.parentElement === fieldset && node.previousElementSibling === grid) return;
            fieldset.insertBefore(node, grid.nextSibling);
          });

          // Relocating unlocks can leave the selected/sticker option with zero-size
          // descendants (grid cell remains). Force those cards to relayout.
          this.repairCollapsedOptions();
        }

        repairCollapsedOptions() {
          this.querySelectorAll('.quantity-breaks__option').forEach((option) => {
            if (!(option instanceof HTMLElement)) return;
            const card = option.querySelector('.quantity-breaks__card');
            if (!(card instanceof HTMLElement)) return;
            if (card.getClientRects().length > 0 && card.offsetHeight > 0) return;

            const previousDisplay = option.style.display;
            option.style.display = 'none';
            void option.offsetHeight;
            option.style.display = previousDisplay;
          });
        }

        syncColumnCount() {
          const grid = this.querySelector('.quantity-breaks__grid');
          const optionCount = grid
            ? grid.querySelectorAll(':scope > .shopify-block .quantity-breaks__option, :scope > .quantity-breaks__option').length
            : this.querySelectorAll('.quantity-breaks__grid .quantity-breaks__option').length;
          if (optionCount === 0) return;

          const maxColumnsDesktop = Math.min(
            3,
            Math.max(
              2,
              Number.parseInt(
                this.dataset.horizontalColumnsDesktop || this.dataset.horizontalColumns || '3',
                10
              ) || 3
            )
          );
          const maxColumnsMobile = Math.min(
            3,
            Math.max(
              2,
              Number.parseInt(
                this.dataset.horizontalColumnsMobile || this.dataset.horizontalColumns || '3',
                10
              ) || 3
            )
          );
          const columnsDesktop = Math.min(optionCount, maxColumnsDesktop);
          const columnsMobile = Math.min(optionCount, maxColumnsMobile);
          const desktopValue = this.classList.contains('quantity-breaks--horizontal-desktop')
            ? `repeat(${columnsDesktop}, minmax(0, 1fr))`
            : 'minmax(0, 1fr)';
          const mobileValue = this.classList.contains('quantity-breaks--horizontal-mobile')
            ? `repeat(${columnsMobile}, minmax(0, 1fr))`
            : 'minmax(0, 1fr)';

          this.style.setProperty('--quantity-breaks-columns-desktop', desktopValue);
          this.style.setProperty('--quantity-breaks-columns-mobile', mobileValue);
          grid?.style.setProperty('--quantity-breaks-columns-desktop', desktopValue);
          grid?.style.setProperty('--quantity-breaks-columns-mobile', mobileValue);

          const list = this.closest('.quantity-breaks-list');
          if (!list) return;

          const groupedCount = list.querySelectorAll('.quantity-breaks__grid .quantity-breaks__option').length || optionCount;
          const groupedColumnsDesktop = Math.min(groupedCount, maxColumnsDesktop);
          const groupedColumnsMobile = Math.min(groupedCount, maxColumnsMobile);
          const groupedDesktopValue = list.querySelector('quantity-breaks.quantity-breaks--horizontal-desktop')
            ? `repeat(${groupedColumnsDesktop}, minmax(0, 1fr))`
            : 'minmax(0, 1fr)';
          const groupedMobileValue = list.querySelector('quantity-breaks.quantity-breaks--horizontal-mobile')
            ? `repeat(${groupedColumnsMobile}, minmax(0, 1fr))`
            : 'minmax(0, 1fr)';
          list.style.setProperty('--quantity-breaks-columns-desktop', groupedDesktopValue);
          list.style.setProperty('--quantity-breaks-columns-mobile', groupedMobileValue);
        }

        unifyRadios() {
          const groupId = this.dataset.groupId || this.dataset.blockId;
          if (!groupId) return;
          this.querySelectorAll('.quantity-breaks__input').forEach((input) => {
            input.name = `quantity-break-${groupId}`;
          });
        }

        syncCompactPickers() {
          const scope = this.getGroupScope();
          scope.querySelectorAll('[data-quantity-break-unit]').forEach((row) => {
            this.refreshCompactRow(row);
          });
        }

        syncVariantLabels() {
          const template = this.dataset.variantSelectorLabel ?? '';
          const scope = this.getGroupScope();
          scope.querySelectorAll('[data-quantity-break-unit]').forEach((row) => {
            const label = row.querySelector('.quantity-breaks__variant-label');
            const select = row.querySelector('select');
            const unit = row.dataset.quantityBreakUnit || '';
            const text = template.replace(/\[x\]/g, unit);
            const isEmpty = text.trim() === '';
            row.classList.toggle('quantity-breaks__variant-row--no-label', isEmpty);
            if (label) {
              label.hidden = isEmpty;
              label.textContent = text;
            }
            if (select && !isEmpty) {
              select.setAttribute('aria-label', text);
            }
          });
        }

        groupWithSiblings() {
          if (!this.classList.contains('quantity-breaks--grouped-start')) return;

          const host = this.closest('.shopify-block') || this;
          const parent = host.parentElement;
          if (!parent || parent.classList.contains('quantity-breaks-list')) return;

          const isBreaksHost = (el) =>
            el.tagName === 'QUANTITY-BREAKS' || Boolean(el.querySelector?.(':scope > quantity-breaks'));

          const group = [];
          let cursor = host;
          while (cursor && isBreaksHost(cursor)) {
            const breaks =
              cursor.tagName === 'QUANTITY-BREAKS' ? cursor : cursor.querySelector(':scope > quantity-breaks');
            if (!breaks?.classList.contains('quantity-breaks--grouped')) break;
            group.push(cursor);
            cursor = cursor.nextElementSibling;
          }
          if (group.length < 2) return;

          const wrapper = document.createElement('div');
          wrapper.className = 'quantity-breaks-list';
          parent.insertBefore(wrapper, host);
          group.forEach((el) => wrapper.appendChild(el));
          this.syncColumnCount();
        }

        initializeSelection() {
          const groupId = this.dataset.groupId;
          if (groupId && this.dataset.blockId !== groupId) return;

          const scope = this.getGroupScope();
          const optionInputs = Array.from(scope.querySelectorAll('.quantity-breaks__input'));
          if (!optionInputs.length) return;

          const selectedOptionId = this.dataset.selectedOptionId || '';
          const preferredById = selectedOptionId
            ? optionInputs.find((input) => {
                const option = input.closest('.quantity-breaks__option');
                return option?.getAttribute('data-option-id') === selectedOptionId;
              })
            : null;

          const preferredIndex = Number.parseInt(this.dataset.selectedOptionIndex || '', 10);
          const preferredByIndex =
            Number.isInteger(preferredIndex) && preferredIndex > 0
              ? optionInputs[preferredIndex - 1]
              : null;

          // Merchant default always wins on init (id, then index). Checked/quantity are fallbacks.
          const selectedInput =
            preferredById || preferredByIndex || scope.querySelector('.quantity-breaks__input:checked') || optionInputs[0];
          if (!selectedInput) return;

          if (this.dataset.blockId) {
            const radioName = `quantity-break-${this.dataset.groupId || this.dataset.blockId}`;
            optionInputs.forEach((input) => {
              input.name = radioName;
            });
          }

          selectedInput.checked = true;
          scope.querySelectorAll('.quantity-breaks__option').forEach((option) => {
            const isSelected = option.contains(selectedInput);
            option.classList.toggle('is-selected', isSelected);
          });

          try {
            this.setProductQuantity(Number(selectedInput.value));
          } catch (error) {
            console.warn('[quantity-breaks] Unable to sync product quantity:', error);
          }

          try {
            this.mountSelectedVariantPickers();
            this.syncOptionPrices();
            this.syncProductPrice();
            this.syncProductUnlocks();
            this.repairCollapsedOptions();
          } catch (error) {
            console.warn('[quantity-breaks] Unable to sync selected option UI:', error);
          }
        }

        escapeHtml(value) {
          return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
        }

        captureMountedVariantState() {
          const scope = this.getGroupScope();
          return Array.from(scope.querySelectorAll('[data-quantity-break-unit]')).map((row) => {
            const variantSelect = row.querySelector('select[data-quantity-break-variant]');
            const optionControls = this.getActiveOptionControls(row);
            return {
              variantId: variantSelect?.value || '',
              optionValues: optionControls.map((control) => this.getControlValue(control)),
            };
          });
        }

        restoreMountedVariantState(state) {
          if (!Array.isArray(state) || !state.length) return;
          const scope = this.getGroupScope();
          const rows = Array.from(scope.querySelectorAll('[data-quantity-break-unit]'));
          rows.forEach((row, index) => {
            const saved = state[index];
            if (!saved) return;
            const optionControls = this.getActiveOptionControls(row);
            saved.optionValues?.forEach((value, controlIndex) => {
              if (!value || !optionControls[controlIndex]) return;
              this.setControlValue(optionControls[controlIndex], value);
            });
            this.refreshCompactRow(row);
            if (saved.variantId) {
              const variantSelect = row.querySelector('select[data-quantity-break-variant]');
              if (
                variantSelect instanceof HTMLSelectElement &&
                Array.from(variantSelect.options).some((option) => option.value === saved.variantId)
              ) {
                variantSelect.value = saved.variantId;
              }
            }
          });
        }

        clearMountedVariantPickers() {
          const scope = this.getGroupScope();
          scope.querySelectorAll('[data-qb-variant-mount]').forEach((mount) => {
            mount.querySelectorAll('[data-quantity-break-unit]').forEach((row) => row.remove());
          });
        }

        mountSelectedVariantPickers() {
          if (this.dataset.showVariantSelector !== 'true') {
            this.clearMountedVariantPickers();
            return;
          }

          const template = this.querySelector('template[data-qb-variant-row-template]');
          if (!(template instanceof HTMLTemplateElement)) {
            this.clearMountedVariantPickers();
            return;
          }

          const preserved = this.captureMountedVariantState();
          this.clearMountedVariantPickers();

          const scope = this.getGroupScope();
          const selectedInput =
            scope.querySelector('.quantity-breaks__input:checked') ||
            this.querySelector('.quantity-breaks__input:checked');
          const selectedOption = selectedInput?.closest('.quantity-breaks__option');
          const mount = selectedOption?.querySelector('[data-qb-variant-mount]');
          if (!selectedOption || !mount) return;

          // Prefer the host that owns the selected option (grouped siblings).
          const host =
            selectedOption.closest('quantity-breaks') instanceof HTMLElement
              ? selectedOption.closest('quantity-breaks')
              : this;
          const hostTemplate =
            host === this
              ? template
              : host.querySelector('template[data-qb-variant-row-template]') || template;
          if (!(hostTemplate instanceof HTMLTemplateElement)) return;

          const quantity =
            Number(selectedOption.dataset.quantity) ||
            Number(selectedInput?.value) ||
            1;
          const parentId = host.dataset.blockId || this.dataset.blockId || 'qb';
          const labelTemplate = host.dataset.variantSelectorLabel ?? this.dataset.variantSelectorLabel ?? '';
          const productTitle = host.dataset.productTitle || this.dataset.productTitle || 'Item';
          let templateHtml = hostTemplate.innerHTML;

          for (let unit = 1; unit <= quantity; unit += 1) {
            const label = labelTemplate.replace(/\[x\]/g, String(unit));
            const a11yLabel = label.trim() === '' ? `${productTitle} #${unit}` : label;
            const html = templateHtml
              .split('%%QB_PARENT_ID%%')
              .join(parentId)
              .split('%%QB_UNIT_ID%%')
              .join(String(unit))
              .split('%%QB_A11Y_LABEL%%')
              .join(this.escapeHtml(a11yLabel));
            const wrapper = document.createElement('div');
            wrapper.innerHTML = html.trim();
            const row = wrapper.firstElementChild;
            if (row) mount.appendChild(row);
          }

          this.syncVariantLabels();
          this.syncCompactPickers();
          this.restoreMountedVariantState(preserved);
        }

        isCompactVariantStyle() {
          const desktop = window.matchMedia('(min-width: 750px)').matches;
          const style = desktop
            ? this.dataset.variantSelectorStyleDesktop
            : this.dataset.variantSelectorStyleMobile;
          return style === 'compact';
        }

        handlePickerPointerDown(event) {
          if (!this.isCompactVariantStyle()) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;

          const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
          const wrapper = path.find(
            (node) => node instanceof Element && node.classList.contains('quantity-breaks__variant-select-wrapper')
          );
          if (!wrapper || !this.contains(wrapper) || wrapper.classList.contains('quantity-breaks__variant-select-full')) {
            return;
          }

          const select = wrapper.querySelector('select[data-quantity-break-option]');
          if (!(select instanceof HTMLSelectElement) || typeof select.showPicker !== 'function') return;

          try {
            select.showPicker();
            event.preventDefault();
          } catch {
            /* Native click on the overlay select still opens the menu. */
          }
        }

        handleChange(event) {
          if (event.target instanceof HTMLInputElement && event.target.matches('.quantity-breaks__input')) {
            const scope = this.getGroupScope();
            scope.querySelectorAll('.quantity-breaks__option').forEach((option) => {
              option.classList.toggle('is-selected', option.contains(event.target));
            });
            this.setProductQuantity(Number(event.target.value));
            this.mountSelectedVariantPickers();
            this.syncOptionPrices();
            this.syncProductPrice();
            this.syncProductUnlocks();
            return;
          }

          if (
            event.target instanceof HTMLSelectElement &&
            event.target.matches('[data-unlock-variant-select]')
          ) {
            this.handleUnlockVariantChange(event.target);
            return;
          }

          if (
            event.target instanceof HTMLInputElement &&
            event.target.matches('fieldset[data-quantity-break-option] input[type="radio"]')
          ) {
            if (this.dataset.showSwatches !== 'true' || this.dataset.swatchStyle === 'dropdown') return;
            this.handleCompactOptionChange(event.target);
            return;
          }

          if (event.target instanceof HTMLSelectElement && event.target.matches('[data-quantity-break-option]')) {
            const inSwatchMenu = event.target.closest('.quantity-breaks__variant-option--swatch-menu');
            const inPlainSwatchDropdown = event.target.closest('.quantity-breaks__variant-option--swatch-dropdown');
            if (this.dataset.showSwatches === 'true') {
              if (inPlainSwatchDropdown) return;
              if (inSwatchMenu && this.dataset.swatchStyle !== 'dropdown') return;
            } else if (inSwatchMenu) {
              return;
            }
            this.handleCompactOptionChange(event.target);
            return;
          }

          if (event.target instanceof HTMLSelectElement && event.target.matches('[data-quantity-break-variant]')) {
            this.syncOptionPrices();
            this.updateSelectedVariant(event.target).catch((error) => {
              if (error?.name !== 'AbortError') {
                console.warn('[quantity-breaks] Unable to update selected variant:', error);
              }
            });
          }
        }

        getSwatchSelectList(root) {
          return (
            root.querySelector('.quantity-breaks__swatch-select-list') ||
            document.querySelector(`.quantity-breaks__swatch-select-list[data-quantity-breaks-swatch-owner="${root.dataset.quantityBreaksSwatchOwner || ''}"]`)
          );
        }

        handleSwatchSelectClick(event) {
          if (this.dataset.showSwatches !== 'true' || this.dataset.swatchStyle !== 'dropdown') return;

          const option = event.target.closest?.('.quantity-breaks__swatch-select-option');
          if (option) {
            const list = option.closest('.quantity-breaks__swatch-select-list');
            const ownerId = list?.dataset.quantityBreaksSwatchOwner;
            const root =
              option.closest('[data-quantity-breaks-swatch-select]') ||
              (ownerId ? this.querySelector(`[data-quantity-breaks-swatch-select][data-quantity-breaks-swatch-owner="${ownerId}"]`) : null);
            if (!root || !this.contains(root)) return;
            if (option.getAttribute('aria-disabled') === 'true') return;
            event.preventDefault();
            this.selectSwatchMenuOption(root, option);
            return;
          }

          const trigger = event.target.closest?.('.quantity-breaks__swatch-select-trigger');
          if (!trigger || !this.contains(trigger)) return;
          const root = trigger.closest('[data-quantity-breaks-swatch-select]');
          if (!root) return;
          event.preventDefault();
          const willOpen = !root.classList.contains('is-open');
          this.closeAllSwatchSelects(willOpen ? root : null);
          this.toggleSwatchSelect(root, willOpen);
        }

        handleSwatchSelectOutside(event) {
          if (!(event.target instanceof Node)) return;
          const openRoot = this.querySelector('[data-quantity-breaks-swatch-select].is-open');
          if (!openRoot) return;
          const list = this.getSwatchSelectList(openRoot);
          if (openRoot.contains(event.target) || list?.contains(event.target)) return;
          this.closeAllSwatchSelects();
        }

        handleSwatchSelectReposition() {
          this.querySelectorAll('[data-quantity-breaks-swatch-select].is-open').forEach((root) => {
            this.positionSwatchSelectList(root);
          });
        }

        handleSwatchSelectKeydown(event) {
          if (event.key === 'Escape') {
            this.closeAllSwatchSelects();
            return;
          }

          const openRoot = this.querySelector('[data-quantity-breaks-swatch-select].is-open');
          if (!openRoot) return;
          const list = this.getSwatchSelectList(openRoot);
          if (!list) return;

          const options = Array.from(list.querySelectorAll('.quantity-breaks__swatch-select-option:not([aria-disabled="true"])'));
          if (!options.length) return;

          const current = list.querySelector('.quantity-breaks__swatch-select-option[aria-selected="true"]');
          let index = Math.max(0, options.indexOf(current));

          if (event.key === 'ArrowDown') {
            event.preventDefault();
            index = Math.min(options.length - 1, index + 1);
            options[index].focus();
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            index = Math.max(0, index - 1);
            options[index].focus();
          } else if (event.key === 'Enter' || event.key === ' ') {
            const focused = document.activeElement?.closest?.('.quantity-breaks__swatch-select-option');
            if (focused && list.contains(focused)) {
              event.preventDefault();
              this.selectSwatchMenuOption(openRoot, focused);
            }
          }
        }

        positionSwatchSelectList(root) {
          const list = this.getSwatchSelectList(root);
          const trigger = root.querySelector('.quantity-breaks__swatch-select-trigger');
          if (!list || !trigger) return;

          const rect = trigger.getBoundingClientRect();
          const menuWidth = Math.max(rect.width, 160);
          const maxLeft = Math.max(12, window.innerWidth - menuWidth - 12);
          const left = Math.min(Math.max(12, rect.left), maxLeft);
          const spaceBelow = window.innerHeight - rect.bottom - 12;
          const spaceAbove = rect.top - 12;
          const openUp = spaceBelow < 180 && spaceAbove > spaceBelow;
          const maxHeight = Math.max(120, Math.min(256, openUp ? spaceAbove : spaceBelow));

          list.style.top = openUp ? 'auto' : `${rect.bottom + 4}px`;
          list.style.bottom = openUp ? `${window.innerHeight - rect.top + 4}px` : 'auto';
          list.style.left = `${left}px`;
          list.style.width = `${menuWidth}px`;
          list.style.minWidth = `${menuWidth}px`;
          list.style.maxHeight = `${maxHeight}px`;
        }

        toggleSwatchSelect(root, open) {
          const list = root.querySelector('.quantity-breaks__swatch-select-list') || this.getSwatchSelectList(root);
          const trigger = root.querySelector('.quantity-breaks__swatch-select-trigger');
          if (!list || !trigger) return;

          if (!root.dataset.quantityBreaksSwatchOwner) {
            root.dataset.quantityBreaksSwatchOwner = `qb-${this.dataset.blockId || 'breaks'}-${Math.random().toString(36).slice(2, 9)}`;
          }

          root.classList.toggle('is-open', open);
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

          if (open) {
            list.dataset.quantityBreaksSwatchOwner = root.dataset.quantityBreaksSwatchOwner;
            list.classList.add('quantity-breaks__swatch-select-list--portal');
            if (list.parentElement !== document.body) {
              document.body.appendChild(list);
            }
            list.hidden = false;
            this.positionSwatchSelectList(root);
            list.querySelector('.quantity-breaks__swatch-select-option[aria-selected="true"]')?.focus();
          } else {
            list.hidden = true;
            list.classList.remove('quantity-breaks__swatch-select-list--portal');
            list.style.top = '';
            list.style.bottom = '';
            list.style.left = '';
            list.style.width = '';
            list.style.minWidth = '';
            list.style.maxHeight = '';
            if (list.parentElement !== root) {
              const select = root.querySelector('select[data-quantity-break-option]');
              if (select) root.insertBefore(list, select);
              else root.appendChild(list);
            }
          }
        }

        closeAllSwatchSelects(except = null) {
          this.querySelectorAll('[data-quantity-breaks-swatch-select].is-open').forEach((root) => {
            if (except && root === except) return;
            this.toggleSwatchSelect(root, false);
          });
        }

        selectSwatchMenuOption(root, option) {
          const select = root.querySelector('select[data-quantity-break-option]');
          const list = this.getSwatchSelectList(root);
          const value = option.dataset.value || '';
          if (!(select instanceof HTMLSelectElement) || !value) return;

          select.value = value;
          list?.querySelectorAll('.quantity-breaks__swatch-select-option').forEach((item) => {
            item.setAttribute('aria-selected', item === option ? 'true' : 'false');
          });

          const label = root.querySelector('[data-quantity-breaks-swatch-trigger-label]');
          const triggerSwatch = root.querySelector('[data-quantity-breaks-swatch-trigger-swatch]');
          const optionLabel = option.querySelector('.quantity-breaks__swatch-select-option-label');
          const optionSwatch = option.querySelector('.quantity-breaks__swatch-select-option-swatch .swatch');
          if (label && optionLabel) label.textContent = optionLabel.textContent.trim();
          if (triggerSwatch && optionSwatch) {
            triggerSwatch.innerHTML = '';
            triggerSwatch.append(optionSwatch.cloneNode(true));
          }

          this.toggleSwatchSelect(root, false);
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        handleCompactOptionChange(control) {
          const row = control.closest('[data-quantity-break-unit]');
          const variantSelect = this.refreshCompactRow(row);
          this.syncOptionPrices();
          if (!variantSelect) return;
          this.updateSelectedVariant(variantSelect).catch((error) => {
            if (error?.name !== 'AbortError') {
              console.warn('[quantity-breaks] Unable to update selected variant:', error);
            }
          });
        }

        refreshCompactRow(row) {
          if (!row) return null;
          this.syncOptionAvailability(row);
          const variantSelect = this.syncCompactRow(row);
          this.syncOptionAvailability(row);
          row.querySelectorAll('select[data-quantity-break-option]').forEach((select) => {
            this.updateCompactSwatch(select);
            this.syncSwatchMenuFromSelect(select);
          });
          return variantSelect;
        }

        getActiveOptionControls(row) {
          return Array.from(row.querySelectorAll('[data-quantity-break-option]'));
        }

        getControlValue(control) {
          if (control instanceof HTMLSelectElement) return control.value;
          if (control instanceof HTMLFieldSetElement) {
            return control.querySelector('input[type="radio"]:checked')?.value ?? '';
          }
          return '';
        }

        setControlValue(control, value) {
          if (control instanceof HTMLSelectElement) {
            if (Array.from(control.options).some((option) => option.value === value)) {
              control.value = value;
            }
            return;
          }
          if (control instanceof HTMLFieldSetElement) {
            const input = control.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
            if (input) input.checked = true;
          }
        }

        getVariantEntries(variantSelect) {
          return Array.from(variantSelect.options).map((option) => {
            let values = [];
            try {
              values = JSON.parse(option.dataset.optionValues || '[]');
            } catch {
              values = [];
            }
            return {
              option,
              values,
              available: !option.disabled,
              id: option.value,
            };
          });
        }

        isOptionValueAvailable(entries, optionIndex, candidateValue, selectedValues) {
          return entries.some(({ values, available }) => {
            if (!available || values[optionIndex] !== candidateValue) return false;
            return selectedValues.every((selected, index) => {
              if (index === optionIndex || !selected) return true;
              return values[index] === selected;
            });
          });
        }

        syncOptionAvailability(row) {
          const variantSelect = row.querySelector('[data-quantity-break-variant]');
          if (!(variantSelect instanceof HTMLSelectElement)) return;

          const activeControls = this.getActiveOptionControls(row);
          if (!activeControls.length) return;

          const entries = this.getVariantEntries(variantSelect);
          const unavailableLabel = this.dataset.unavailableLabel || 'Unavailable';
          const selectedValues = activeControls.map((control) => this.getControlValue(control));

          activeControls.forEach((control, optionIndex) => {
            const optionName = control.getAttribute('data-quantity-break-option') || '';
            row.querySelectorAll('[data-quantity-break-option]').forEach((target) => {
              if (target.getAttribute('data-quantity-break-option') !== optionName) return;
              this.applyAvailabilityToControl(
                target,
                optionIndex,
                selectedValues,
                entries,
                unavailableLabel
              );
            });
            selectedValues[optionIndex] = this.getControlValue(control);
          });
        }

        applyAvailabilityToControl(control, optionIndex, selectedValues, entries, unavailableLabel) {
          if (control instanceof HTMLSelectElement) {
            Array.from(control.options).forEach((option) => {
              const available = this.isOptionValueAvailable(
                entries,
                optionIndex,
                option.value,
                selectedValues
              );
              const baseLabel = option.dataset.optionLabel || option.value;
              option.disabled = !available;
              option.dataset.optionAvailable = available ? 'true' : 'false';
              option.textContent = available ? baseLabel : `${baseLabel} - ${unavailableLabel}`;
            });

            if (control.selectedOptions[0]?.disabled) {
              const firstAvailable = Array.from(control.options).find((option) => !option.disabled);
              if (firstAvailable) control.value = firstAvailable.value;
            }

            const root = control.closest('[data-quantity-breaks-swatch-select]');
            if (root) {
              const list = this.getSwatchSelectList(root);
              list?.querySelectorAll('.quantity-breaks__swatch-select-option').forEach((item) => {
                const value = item.dataset.value || '';
                const available = this.isOptionValueAvailable(entries, optionIndex, value, selectedValues);
                const baseLabel = item.dataset.optionLabel || value;
                item.classList.toggle('quantity-breaks__swatch-select-option--disabled', !available);
                item.setAttribute('aria-disabled', available ? 'false' : 'true');
                const labelEl = item.querySelector('.quantity-breaks__swatch-select-option-label');
                if (labelEl) {
                  labelEl.textContent = available ? baseLabel : `${baseLabel} - ${unavailableLabel}`;
                }
              });
            }
            return;
          }

          if (control instanceof HTMLFieldSetElement) {
            control.querySelectorAll('input[type="radio"]').forEach((input) => {
              const available = this.isOptionValueAvailable(
                entries,
                optionIndex,
                input.value,
                selectedValues
              );
              input.disabled = !available;
              input.dataset.optionAvailable = available ? 'true' : 'false';
              input.closest('.variant-option__button-label')?.classList.toggle('is-unavailable', !available);
            });

            const checked = control.querySelector('input[type="radio"]:checked');
            if (checked?.disabled) {
              const firstAvailable = control.querySelector('input[type="radio"]:not(:disabled)');
              if (firstAvailable) firstAvailable.checked = true;
            }
          }
        }

        syncCompactRow(row) {
          if (!row) return null;
          const optionControls = this.getActiveOptionControls(row);
          const variantSelect = row.querySelector('[data-quantity-break-variant]');
          if (!optionControls.length || !(variantSelect instanceof HTMLSelectElement)) return variantSelect;

          const entries = this.getVariantEntries(variantSelect);
          const values = optionControls.map((control) => this.getControlValue(control));

          let matching = entries.find(
            (entry) =>
              entry.available &&
              entry.values.length === values.length &&
              entry.values.every((value, index) => value === values[index])
          );

          if (!matching) {
            matching = entries.find(
              (entry) =>
                entry.available &&
                entry.values.every((value, index) => !values[index] || value === values[index])
            );
          }

          if (!matching) {
            matching = entries.find((entry) => entry.available);
          }

          if (!matching) return variantSelect;

          matching.values.forEach((value, index) => {
            const control = optionControls[index];
            if (!control) return;
            const optionName = control.getAttribute('data-quantity-break-option') || '';
            row.querySelectorAll('[data-quantity-break-option]').forEach((target) => {
              if (target.getAttribute('data-quantity-break-option') !== optionName) return;
              this.setControlValue(target, value);
            });
          });

          variantSelect.value = matching.id;
          return variantSelect;
        }

        syncSwatchMenuFromSelect(select) {
          const root = select.closest('[data-quantity-breaks-swatch-select]');
          if (!root) return;
          const list = this.getSwatchSelectList(root) || root;
          const value = select.value;
          const option = list.querySelector(`.quantity-breaks__swatch-select-option[data-value="${CSS.escape(value)}"]`);
          if (!option) return;

          list.querySelectorAll('.quantity-breaks__swatch-select-option').forEach((item) => {
            item.setAttribute('aria-selected', item === option ? 'true' : 'false');
          });
          const label = root.querySelector('[data-quantity-breaks-swatch-trigger-label]');
          const triggerSwatch = root.querySelector('[data-quantity-breaks-swatch-trigger-swatch]');
          const optionLabel = option.querySelector('.quantity-breaks__swatch-select-option-label');
          const optionSwatch = option.querySelector('.quantity-breaks__swatch-select-option-swatch .swatch');
          const unavailable = option.getAttribute('aria-disabled') === 'true';
          root.classList.toggle('is-unavailable', unavailable);
          if (label) {
            const baseLabel = option.dataset.optionLabel || optionLabel?.textContent?.trim() || value;
            const unavailableLabel = this.dataset.unavailableLabel || 'Unavailable';
            label.textContent = unavailable ? `${baseLabel} - ${unavailableLabel}` : baseLabel;
          }
          if (triggerSwatch && optionSwatch) {
            triggerSwatch.innerHTML = '';
            triggerSwatch.append(optionSwatch.cloneNode(true));
          }
        }

        updateCompactSwatch(select) {
          const wrapper = select.closest('.quantity-breaks__variant-select-wrapper');
          if (!wrapper) return;

          const selected = select.selectedOptions[0];
          const label = wrapper.querySelector('[data-quantity-break-option-label]');
          const available = Boolean(selected) && !selected.disabled;
          wrapper.classList.toggle('is-unavailable', !available);
          if (label && selected) {
            label.textContent = selected.textContent.trim();
          }
        }

        getSelectedVariantOptions(select) {
          const selectedOption = select.selectedOptions[0];
          if (!selectedOption) return [];

          try {
            const names = JSON.parse(select.dataset.optionNames || selectedOption.dataset.optionNames || '[]');
            const values = JSON.parse(selectedOption.dataset.optionValues || '[]');
            return names.map((name, index) => ({ name, value: values[index] })).filter(({ value }) => value != null);
          } catch {
            return [];
          }
        }

        syncMainVariantPicker(variantPicker, selectedOptions) {
          const valuesByName = new Map(selectedOptions.map(({ name, value }) => [name, value]));
          let selectedPickerOption = null;

          variantPicker.querySelectorAll('select').forEach((select) => {
            const optionName = select.options[0]?.dataset.optionName;
            const value = optionName ? valuesByName.get(optionName) : null;
            if (value == null) return;

            const matchingOption = Array.from(select.options).find((option) => option.value === value);
            if (!matchingOption) return;

            select.value = value;
            variantPicker.updateSelectedOption(select);
            selectedPickerOption = matchingOption;
          });

          variantPicker.querySelectorAll('fieldset').forEach((fieldset) => {
            const inputs = Array.from(fieldset.querySelectorAll('input[data-option-name]'));
            const optionName = inputs[0]?.dataset.optionName;
            const value = optionName ? valuesByName.get(optionName) : null;
            if (value == null) return;

            const matchingInput = inputs.find((input) => input.value === value);
            if (!matchingInput) return;

            variantPicker.updateSelectedOption(matchingInput);
            selectedPickerOption = matchingInput;
          });

          return selectedPickerOption;
        }

        async updateSelectedVariant(select) {
          const variantId = select.value;
          const selectedOptions = this.getSelectedVariantOptions(select);
          if (!variantId || selectedOptions.length === 0) return;

          const variantPicker = this.scope.querySelector('variant-picker[ref="mainVariantPicker"]');
          if (variantPicker) {
            await customElements.whenDefined('variant-picker');
            this.variantUpdateController?.abort();

            const selectedPickerOption = this.syncMainVariantPicker(variantPicker, selectedOptions);
            if (!selectedPickerOption) return;

            const currentUrl = variantPicker.dataset.productUrl?.split('?')[0];
            const connectedProductUrl = selectedPickerOption.dataset.connectedProductUrl || '';
            const loadsNewProduct =
              variantPicker.dataset.templateProductMatch === 'true' &&
              connectedProductUrl &&
              connectedProductUrl !== currentUrl;
            const morphElementSelector = loadsNewProduct
              ? 'main'
              : variantPicker.closest('featured-product-information')
                ? 'featured-product-information'
                : undefined;

            variantPicker.fetchUpdatedSection(variantPicker.buildRequestUrl(selectedPickerOption), {
              morphElementSelector,
              detail: {
                optionValueId: selectedPickerOption.dataset.optionValueId || '',
                variantId,
                connectedProductUrl,
              },
            });

            if (variantPicker.dataset.templateProductMatch === 'true') {
              const url = new URL(window.location.href);
              url.searchParams.set('variant', variantId);
              if (loadsNewProduct) url.pathname = connectedProductUrl;
              history.replaceState({}, '', url.toString());
            }
            return;
          }

          await this.dispatchStandaloneVariantUpdate(variantId, selectedOptions);
        }

        async dispatchStandaloneVariantUpdate(variantId, selectedOptions) {
          const generation = ++this.variantUpdateGeneration;
          this.variantUpdateController?.abort();
          this.variantUpdateController = new AbortController();
          const { signal } = this.variantUpdateController;
          const { ProductSelectEvent } = await import('@shopify/events');
          if (signal.aborted || generation !== this.variantUpdateGeneration) return;

          const deferredEventPromise = ProductSelectEvent.createPromise();
          this.dispatchEvent(
            new ProductSelectEvent({
              product: {
                id: this.dataset.productId || '',
                title: this.dataset.productTitle || '',
                handle: this.dataset.productHandle || '',
              },
              selectedOptions,
              detail: { variantId },
              promise: deferredEventPromise.promise,
            })
          );

          try {
            const requestUrl = new URL(this.dataset.productUrl || window.location.pathname, window.location.origin);
            requestUrl.searchParams.set('variant', variantId);
            if (this.dataset.sectionId) requestUrl.searchParams.set('section_id', this.dataset.sectionId);

            const response = await fetch(requestUrl.toString(), { signal });
            if (!response.ok) throw new Error(`Variant section request failed with status ${response.status}`);

            const responseText = await response.text();
            if (signal.aborted || generation !== this.variantUpdateGeneration) {
              throw new DOMException('Variant update was superseded', 'AbortError');
            }

            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selector = `quantity-breaks[data-block-id="${CSS.escape(this.dataset.blockId || '')}"]`;
            const updatedBlock = html.querySelector(selector);
            const variantJson = updatedBlock?.querySelector('[data-quantity-breaks-selected-variant]')?.textContent;
            if (!updatedBlock || !variantJson) throw new Error('Updated quantity-breaks variant data was not found');

            const resource = JSON.parse(variantJson);
            deferredEventPromise.resolve({
              variant: resource,
              detail: {
                html,
                productId: this.dataset.productId || '',
                sourceId: variantId,
                resource,
              },
            });

            if (this.dataset.templateProductMatch === 'true') {
              const url = new URL(window.location.href);
              url.searchParams.set('variant', variantId);
              history.replaceState({}, '', url.toString());
            }
          } catch (error) {
            deferredEventPromise.reject(error);
            throw error;
          }
        }

        getSelectedCartItems() {
          const selectedOption = this.querySelector('.quantity-breaks__input:checked');
          const quantity = Number(selectedOption?.value) || 0;
          const option = selectedOption?.closest('.quantity-breaks__option');
          const selectors = option?.querySelectorAll('[data-quantity-break-variant]');
          const items = [];

          if (selectors?.length) {
            const quantitiesByVariant = new Map();
            selectors.forEach((selector) => {
              if (!(selector instanceof HTMLSelectElement) || !selector.value) return;
              quantitiesByVariant.set(
                selector.value,
                (quantitiesByVariant.get(selector.value) || 0) + 1
              );
            });
            quantitiesByVariant.forEach((qty, variantId) => {
              items.push({ variantId, quantity: qty });
            });
          } else if (quantity > 0) {
            const variantId = this.getCurrentVariantId();
            if (variantId) {
              items.push({ variantId, quantity });
            }
          }

          return this.withFreeGiftItems(items);
        }

        getCurrentVariantId() {
          const form =
            this.closest('.product-information')?.querySelector('product-form-component form') ||
            this.scope?.querySelector?.('product-form-component form');
          const input = form?.querySelector('[name="id"]');
          if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement) {
            return input.value || null;
          }

          try {
            const script = this.querySelector('[data-quantity-breaks-selected-variant]');
            const variant = script ? JSON.parse(script.textContent || 'null') : null;
            return variant?.id ? String(variant.id) : null;
          } catch {
            return null;
          }
        }

        getSelectedOptionGifts(
          option = this.querySelector('.quantity-breaks__input:checked')?.closest('.quantity-breaks__option')
        ) {
          if (!(option instanceof HTMLElement)) return [];
          if (option.dataset.freeGiftEnabled !== 'true') return [];

          const discount = Math.max(0, Math.min(100, Number(option.dataset.freeGiftDiscount) || 0));
          const gifts = [];
          const seen = new Set();

          option.querySelectorAll('[data-quantity-breaks-extra-product]').forEach((banner) => {
            if (!(banner instanceof HTMLElement)) return;
            const giftVariantId = String(banner.dataset.freeGiftVariantId || '');
            if (!giftVariantId || seen.has(giftVariantId)) return;
            seen.add(giftVariantId);
            gifts.push({
              variantId: giftVariantId,
              discount: Number(banner.dataset.freeGiftDiscount) || discount,
              price: Number(banner.dataset.freeGiftPrice) || 0,
            });
          });

          return gifts.slice(0, 5);
        }

        getUnlockedGiftItems() {
          const selectedQty = Number(
            this.querySelector('.quantity-breaks__input:checked')?.value || 0
          );
          const gifts = [];
          const seen = new Set();

          this.querySelectorAll('[data-quantity-breaks-unlock-product]').forEach((el) => {
            if (!(el instanceof HTMLElement)) return;
            if (el.dataset.autoAdd !== 'true') return;
            const unlockQty = Number(el.dataset.unlockQuantity) || 0;
            if (!(selectedQty >= unlockQty)) return;
            const giftVariantId = String(el.dataset.freeGiftVariantId || '');
            if (!giftVariantId || seen.has(giftVariantId)) return;
            seen.add(giftVariantId);
            gifts.push({
              variantId: giftVariantId,
              discount: Number(el.dataset.freeGiftDiscount) || 100,
              price: Number(el.dataset.freeGiftPrice) || 0,
            });
          });

          return gifts;
        }

        handleUnlockVariantChange(select) {
          if (!(select instanceof HTMLSelectElement)) return;
          const card = select.closest('[data-quantity-breaks-unlock-product]');
          if (!(card instanceof HTMLElement)) return;

          let variants = [];
          try {
            const script = card.querySelector('[data-unlock-variants]');
            variants = script ? JSON.parse(script.textContent || '[]') : [];
          } catch {
            variants = [];
          }

          const variant = variants.find((item) => String(item?.id) === String(select.value));
          if (!variant) return;

          card.dataset.freeGiftVariantId = String(variant.id);
          card.dataset.freeGiftPrice = String(variant.price || 0);

          const discount = Math.max(0, Math.min(100, Number(card.dataset.freeGiftDiscount) || 100));
          const original = Number(variant.price) || 0;
          const finalPrice = Math.round((original * (100 - discount)) / 100);
          const isFree = discount >= 100 || finalPrice <= 0;
          const freeText = (card.dataset.freeText || '').trim() || 'Free';

          const compareEl = card.querySelector('[data-unlock-product-compare]');
          const finalEl = card.querySelector('[data-unlock-product-final]');
          if (compareEl instanceof HTMLElement) {
            if (original > finalPrice) {
              compareEl.hidden = false;
              compareEl.innerHTML = `<bdi>${this.escapeHtml(this.formatMoney(original))}</bdi>`;
            } else {
              compareEl.hidden = true;
              compareEl.textContent = '';
            }
          }
          if (finalEl instanceof HTMLElement) {
            finalEl.innerHTML = isFree
              ? this.escapeHtml(freeText)
              : `<bdi>${this.escapeHtml(this.formatMoney(finalPrice))}</bdi>`;
          }

          if (card.dataset.customImage === 'true') return;
          const imageUrl = String(variant.image || '').trim();
          if (!imageUrl) return;
          const img = card.querySelector('.quantity-breaks__unlock-product-image');
          if (img instanceof HTMLImageElement) {
            img.src = imageUrl;
            img.srcset = '';
          }
        }

        syncProductUnlocks() {
          const selectedQty = Number(
            this.querySelector('.quantity-breaks__input:checked')?.value || 0
          );
          const unlocksRoot = this.querySelector('[data-quantity-breaks-unlocks]');
          const progressLockedLabel = (unlocksRoot?.dataset.progressLockedLabel || '').trim();
          const progressUnlockedLabel = (unlocksRoot?.dataset.unlockedLabel || '').trim();
          const products = Array.from(
            this.querySelectorAll('[data-quantity-breaks-unlock-product]')
          ).filter((el) => el instanceof HTMLElement);

          products.forEach((el) => {
            const unlockQty = Number(el.dataset.unlockQuantity) || 0;
            const unlocked = selectedQty >= unlockQty;
            el.classList.toggle('is-unlocked', unlocked);
            el.classList.toggle('is-locked', !unlocked);
            el.setAttribute('aria-locked', unlocked ? 'false' : 'true');

            const variantSelect = el.querySelector('[data-unlock-variant-select]');
            if (variantSelect instanceof HTMLSelectElement) {
              variantSelect.disabled = !unlocked;
            }
          });

          const progressRoot = unlocksRoot?.querySelector('[data-unlocks-progress]');
          if (!(progressRoot instanceof HTMLElement)) return;

          if (!products.length) {
            progressRoot.hidden = true;
            progressRoot.innerHTML = '';
            return;
          }

          let steps = Array.from(progressRoot.querySelectorAll('[data-unlock-progress-step]'));
          if (steps.length !== products.length) {
            progressRoot.innerHTML = products
              .map((product, index) => {
                const unlockQty = Number(product.dataset.unlockQuantity) || 0;
                const unlocked = selectedQty >= unlockQty;
                const label = unlocked ? progressUnlockedLabel : progressLockedLabel;
                const stateClass = unlocked ? 'is-unlocked' : 'is-locked';
                return `
                  <li
                    class="quantity-breaks__unlocks-progress-step ${stateClass}"
                    data-unlock-progress-step
                    data-unlock-quantity="${unlockQty}"
                  >
                    <span class="quantity-breaks__unlocks-progress-marker" aria-hidden="true">
                      <span class="quantity-breaks__unlocks-progress-check">
                        <svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor" focusable="false">
                          <path d="M7.833 14.167 3.666 10l1.167-1.167 3 3 7.334-7.333L16.333 5.667 7.833 14.167Z"></path>
                        </svg>
                      </span>
                      <span class="quantity-breaks__unlocks-progress-index">${index + 1}</span>
                    </span>
                    <span class="quantity-breaks__unlocks-progress-label" data-unlock-progress-label>${this.escapeHtml(label)}</span>
                  </li>
                `;
              })
              .join('');
            steps = Array.from(progressRoot.querySelectorAll('[data-unlock-progress-step]'));
          }

          progressRoot.hidden = false;
          steps.forEach((el, index) => {
            if (!(el instanceof HTMLElement)) return;
            const product = products[index];
            const unlockQty = Number(
              product?.dataset.unlockQuantity || el.dataset.unlockQuantity || 0
            );
            const unlocked = selectedQty >= unlockQty;
            el.dataset.unlockQuantity = String(unlockQty);
            el.classList.toggle('is-unlocked', unlocked);
            el.classList.toggle('is-locked', !unlocked);

            const labelEl = el.querySelector('[data-unlock-progress-label]');
            if (!(labelEl instanceof HTMLElement)) return;
            labelEl.textContent = unlocked ? progressUnlockedLabel : progressLockedLabel;
          });
        }

        withFreeGiftItems(items) {
          const gifts = [...this.getSelectedOptionGifts(), ...this.getUnlockedGiftItems()];
          if (!gifts.length) return items;

          const nextItems = [...items];
          const seen = new Set(
            nextItems.map((item) => String(item.variantId || '')).filter(Boolean)
          );

          gifts.forEach((gift) => {
            const giftVariantId = String(gift.variantId || '');
            if (!giftVariantId || seen.has(giftVariantId)) return;
            seen.add(giftVariantId);

            const discount = Math.max(0, Math.min(100, Number(gift.discount) || 0));
            // Always add +1 per unlocked threshold. Matching properties let Shopify merge
            // into the existing gift line; the app updates `_qb_gift_qty` to the cumulative
            // entitled amount (e.g. 2 when two products unlock the same gift).
            nextItems.push({
              variantId: giftVariantId,
              quantity: 1,
              properties: {
                _qb_free_gift: discount >= 100 ? 'true' : 'false',
                _qb_gift_discount: String(discount),
              },
            });
          });

          return nextItems;
        }

        formatMoney(cents) {
          const amount = Number(cents);
          if (!Number.isFinite(amount)) return '';
          const useCurrency = this.dataset.currencyCodeEnabled === 'true';
          const amountPlaceholder = '{' + '{amount}}';
          const format = useCurrency
            ? this.dataset.moneyWithCurrencyFormat || this.dataset.moneyFormat || amountPlaceholder
            : this.dataset.moneyFormat || amountPlaceholder;
          const value = (Math.abs(amount) / 100).toFixed(2);
          const [dollars, centsPart] = value.split('.');
          const thousands = (input, separator) => input.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${separator}`);
          const amountPlain = `${thousands(dollars, ',')}.${centsPart}`;
          const amountComma = `${thousands(dollars, '.')},${centsPart}`;
          const amountNoDecimals = thousands(dollars, ',');
          const amountApostrophe = `${thousands(dollars, "'")}.${centsPart}`;
          const amountWithoutZeros = centsPart === '00' ? thousands(dollars, ',') : amountPlain;

          return format
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
            .replace(/\{\{\s*amount_with_period_and_thousands_separator\s*\}\}/g, amountPlain)
            .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amountApostrophe)
            .replace(/\{\{\s*amount_without_trailing_zeros\s*\}\}/g, amountWithoutZeros)
            .replace(/\{\{\s*amount\s*\}\}/g, amountPlain);
        }

        getSelectedUnitPrices(option) {
          if (!(option instanceof HTMLElement)) return [];
          const selectors = option.querySelectorAll('[data-quantity-break-variant]');
          if (!selectors.length) return [];

          return Array.from(selectors).flatMap((select) => {
            if (!(select instanceof HTMLSelectElement)) return [];
            const selected = select.selectedOptions?.[0];
            if (!selected) return [];
            const price = Number(selected.dataset.price);
            if (!Number.isFinite(price)) return [];
            const compare = Number(selected.dataset.compareAtPrice) || 0;
            return [{ price, compare: compare > price ? compare : 0 }];
          });
        }

        getOptionPricing(option) {
          if (!(option instanceof HTMLElement)) return null;
          const discount = Math.max(0, Math.min(100, Number(option.dataset.discount) || 0));
          const keepPercent = (100 - discount) / 100;
          const units = this.getSelectedUnitPrices(option);
          if (!units.length) return null;

          let originalTotal = units.reduce((sum, unit) => sum + unit.price, 0);
          let compareTotal = units.reduce(
            (sum, unit) => sum + (unit.compare > 0 ? unit.compare : unit.price),
            0
          );
          let discountedTotal = units.reduce((sum, unit) => sum + Math.round(unit.price * keepPercent), 0);
          // Per-unit averages stay product-only; gifts are added to the option total below.
          const unitDiscountedAverage = Math.round(discountedTotal / units.length);
          const unitOriginalAverage = Math.round(originalTotal / units.length);
          const unitCompareAverage = Math.round(compareTotal / units.length);

          this.getSelectedOptionGifts(option).forEach((gift) => {
            const giftPrice = Number(gift.price) || 0;
            if (!(giftPrice > 0)) return;
            const giftDiscount = Math.max(0, Math.min(100, Number(gift.discount) || 0));
            const giftFinal = Math.round((giftPrice * (100 - giftDiscount)) / 100);
            if (!(giftFinal > 0)) return;
            originalTotal += giftPrice;
            compareTotal += giftPrice;
            discountedTotal += giftFinal;
          });

          const isSelected = Boolean(option.querySelector('.quantity-breaks__input:checked'));
          if (isSelected) {
            this.getUnlockedGiftItems().forEach((gift) => {
              const giftPrice = Number(gift.price) || 0;
              if (!(giftPrice > 0)) return;
              const giftDiscount = Math.max(0, Math.min(100, Number(gift.discount) || 0));
              const giftFinal = Math.round((giftPrice * (100 - giftDiscount)) / 100);
              if (!(giftFinal > 0)) return;
              originalTotal += giftPrice;
              compareTotal += giftPrice;
              discountedTotal += giftFinal;
            });
          }

          const hasBreaksCompare = originalTotal > discountedTotal;
          const hasProductCompare = compareTotal > originalTotal && compareTotal > discountedTotal;

          return {
            discount,
            unitCount: units.length,
            originalTotal,
            compareTotal,
            discountedTotal,
            unitDiscountedAverage,
            unitOriginalAverage,
            unitCompareAverage,
            hasBreaksCompare,
            hasProductCompare,
          };
        }

        updateOptionPriceDisplay(option) {
          const pricing = this.getOptionPricing(option);
          const priceEl = option?.querySelector('.quantity-breaks__price');
          if (!pricing || !(priceEl instanceof HTMLElement)) return;

          const discountedFormatted = this.formatMoney(pricing.discountedTotal);
          const breaksCompareFormatted = this.formatMoney(pricing.originalTotal);
          const productCompareFormatted = this.formatMoney(pricing.compareTotal);
          const unitDiscountedFormatted = this.formatMoney(pricing.unitDiscountedAverage);
          const unitBreaksCompareFormatted = this.formatMoney(pricing.unitOriginalAverage);
          const unitProductCompareFormatted = this.formatMoney(pricing.unitCompareAverage);
          const onSale = pricing.hasBreaksCompare || pricing.hasProductCompare;

          priceEl.dataset.productPrice = discountedFormatted;
          priceEl.dataset.breaksComparePrice = breaksCompareFormatted;
          priceEl.dataset.productComparePrice = productCompareFormatted;
          priceEl.dataset.breaksCompareOnSale = pricing.hasBreaksCompare ? 'true' : 'false';
          priceEl.dataset.productCompareOnSale = pricing.hasProductCompare ? 'true' : 'false';
          priceEl.dataset.productPriceOnSale = onSale ? 'true' : 'false';
          priceEl.classList.toggle('price-container--on-sale', onSale);

          const totalStack = priceEl.querySelector('.quantity-breaks__price--total');
          const unitStack = priceEl.querySelector('.quantity-breaks__price--unit');
          const suffix = this.dataset.perUnitPriceSuffix || '';

          const renderStack = (stack, finalText, breaksCompareText, productCompareText) => {
            if (!(stack instanceof HTMLElement)) return;
            stack.replaceChildren();

            if (pricing.hasProductCompare) {
              const compare = document.createElement('s');
              compare.className =
                'quantity-breaks__compare-price quantity-breaks__compare-price--product price-item__group price-item--regular compare-at-price';
              const compareBdi = document.createElement('bdi');
              compareBdi.textContent = productCompareText;
              compare.appendChild(compareBdi);
              stack.appendChild(compare);
            }

            if (pricing.hasBreaksCompare) {
              const compare = document.createElement('s');
              compare.className =
                'quantity-breaks__compare-price quantity-breaks__compare-price--breaks price-item__group price-item--regular compare-at-price';
              const compareBdi = document.createElement('bdi');
              compareBdi.textContent = breaksCompareText;
              compare.appendChild(compareBdi);
              stack.appendChild(compare);
            }

            const final = document.createElement('span');
            final.className = 'quantity-breaks__final-price price-item__group';
            const finalBdi = document.createElement('bdi');
            finalBdi.textContent = finalText;
            final.appendChild(finalBdi);
            if (stack === unitStack && suffix) {
              const suffixEl = document.createElement('span');
              suffixEl.className = 'quantity-breaks__price-suffix';
              suffixEl.textContent = suffix;
              final.appendChild(suffixEl);
            }
            stack.appendChild(final);
          };

          renderStack(totalStack, discountedFormatted, breaksCompareFormatted, productCompareFormatted);
          renderStack(unitStack, unitDiscountedFormatted, unitBreaksCompareFormatted, unitProductCompareFormatted);
        }

        syncOptionPrices() {
          this.querySelectorAll('.quantity-breaks__option').forEach((option) => {
            this.updateOptionPriceDisplay(option);
          });
          this.syncProductPrice();
        }

        remountFromEditor() {
          const run = () => {
            if (!this.isConnected) return;
            this.unifyRadios();
            this.groupWithSiblings();
            this.relocateUnlocks();
            this.syncColumnCount();
            this.initializeSelection();
            this.syncOptionPrices();
            this.syncProductUnlocks();
          };

          run();
          requestAnimationFrame(run);
          clearTimeout(this._editorRemountTimer);
          this._editorRemountTimer = setTimeout(run, 50);
          clearTimeout(this._editorRemountTimerLate);
          this._editorRemountTimerLate = setTimeout(run, 250);
        }

        handleQuantityUpdate(event) {
          if (event.target.closest('quantity-breaks') === this) return;
          const quantity = String(event.detail?.quantity ?? '');
          const matchingInput = this.querySelector(`input[value="${CSS.escape(quantity)}"]`);
          if (matchingInput) matchingInput.checked = true;
          this.mountSelectedVariantPickers();
          this.syncOptionPrices();
        }

        handleProductSelect(event) {
          if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;

          event.promise
            .then(({ detail }) => {
              if (!detail?.html || !this.dataset.blockId) return;

              if (detail.newProduct) {
                this.dataset.productId = detail.newProduct.id;
              } else if (detail.productId && detail.productId !== this.dataset.productId) {
                return;
              }

              const selector = `quantity-breaks[data-block-id="${CSS.escape(this.dataset.blockId)}"]`;
              const updatedBlock = detail.html.querySelector(selector);
              if (!updatedBlock) return;

              const currentOptions = this.querySelectorAll('.quantity-breaks__option');
              const updatedOptions = updatedBlock.querySelectorAll('.quantity-breaks__option');
              currentOptions.forEach((option, index) => {
                const updatedOption = updatedOptions[index];
                if (!updatedOption) return;

                const currentSubtitle = option.querySelector('.quantity-breaks__subtitle');
                const updatedSubtitle = updatedOption.querySelector('.quantity-breaks__subtitle');
                if (currentSubtitle && updatedSubtitle) {
                  currentSubtitle.replaceWith(updatedSubtitle.cloneNode(true));
                } else if (currentSubtitle && !updatedSubtitle) {
                  currentSubtitle.remove();
                } else if (!currentSubtitle && updatedSubtitle) {
                  option
                    .querySelector('.quantity-breaks__text')
                    ?.appendChild(updatedSubtitle.cloneNode(true));
                }

                const currentPrice = option.querySelector('.quantity-breaks__price');
                const updatedPrice = updatedOption.querySelector('.quantity-breaks__price');
                if (currentPrice && updatedPrice) currentPrice.replaceWith(updatedPrice.cloneNode(true));

                const currentImage = option.querySelector('.quantity-breaks__image');
                const updatedImage = updatedOption.querySelector('.quantity-breaks__image');
                if (currentImage && updatedImage) {
                  currentImage.replaceWith(updatedImage.cloneNode(true));
                } else if (currentImage && !updatedImage) {
                  currentImage.remove();
                } else if (!currentImage && updatedImage) {
                  option
                    .querySelector('.quantity-breaks__text')
                    ?.before(updatedImage.cloneNode(true));
                }
              });

              requestAnimationFrame(() => {
                this.syncOptionPrices();
                this.syncProductPrice();
              });
            })
            .catch((error) => {
              if (error?.name !== 'AbortError') console.warn('[quantity-breaks] Variant update failed:', error);
            });
        }

        setProductQuantity(quantity) {
          const component = this.getQuantityComponent();
          const input = component?.querySelector('input[name="quantity"]');
          if (!component || !input || !Number.isFinite(quantity)) return;
          component.setValue(String(quantity));
          // Clamps to the variant's quantity rules (min/max/cart quantity) before notifying the form.
          component.updateCartQuantity();
          component.onQuantityChange();
        }

        updatePriceContainer(container, { onSale, price, comparePrice, saleFirst, saleLabel, regularLabel }) {
          if (!container) return;

          container.classList.toggle('price-container--on-sale', onSale);
          container.replaceChildren();

          const appendGroup = (className, label, amount) => {
            const group = document.createElement('span');
            group.className = className;
            if (label) {
              const hidden = document.createElement('span');
              hidden.className = 'visually-hidden';
              hidden.textContent = `${label}\u00a0`;
              group.append(hidden);
            }
            const bdi = document.createElement('bdi');
            bdi.textContent = amount;
            group.append(bdi);
            container.append(group);
          };

          if (onSale && comparePrice) {
            const saleGroup = () => appendGroup('price-item__group price', saleLabel, price);
            const compareGroup = () =>
              appendGroup('price-item__group price-item--regular compare-at-price', regularLabel, comparePrice);
            if (saleFirst) {
              saleGroup();
              compareGroup();
            } else {
              compareGroup();
              saleGroup();
            }
          } else {
            appendGroup('price', '', price);
          }
        }

        applySyncedPrice(host, priceState) {
          if (!host) return;

          this.updatePriceContainer(host.querySelector('[ref="priceContainer"]'), {
            ...priceState,
            saleFirst: host.dataset.showSalePriceFirst !== 'false',
          });

          const volumeNote = host.querySelector('[ref="volumePricingNote"], .volume-pricing-note');
          if (volumeNote) volumeNote.hidden = true;
        }

        syncProductPrice() {
          if (this.dataset.syncProductPrice !== 'true') return;

          const selectedOption = this.getGroupScope().querySelector('.quantity-breaks__input:checked')?.closest(
            '.quantity-breaks__option'
          );
          const priceSource = selectedOption?.querySelector('.quantity-breaks__price');
          const price = priceSource?.dataset.productPrice;
          if (!priceSource || !price) return;

          const useProductCompare = this.dataset.comparePriceSource === 'product';
          const productComparePrice = priceSource.dataset.productComparePrice || '';
          const breaksComparePrice = priceSource.dataset.breaksComparePrice || '';
          const hasProductCompare =
            useProductCompare &&
            priceSource.dataset.productCompareOnSale === 'true' &&
            productComparePrice !== '';
          const hasBreaksCompare = priceSource.dataset.breaksCompareOnSale === 'true' && breaksComparePrice !== '';
          const onSale = hasProductCompare || hasBreaksCompare;
          const comparePrice = hasProductCompare ? productComparePrice : hasBreaksCompare ? breaksComparePrice : '';
          const priceState = {
            onSale,
            price,
            comparePrice,
            saleLabel: this.dataset.priceSaleLabel || '',
            regularLabel: this.dataset.priceRegularLabel || '',
          };
          const productId = this.dataset.productId || '';
          const matchesProduct = (element) => !productId || element.dataset.productId === productId;
          const section = this.closest('.shopify-section') || this.scope;

          Array.from(this.scope.querySelectorAll('product-price'))
            .filter(matchesProduct)
            .forEach((productPrice) => this.applySyncedPrice(productPrice, priceState));

          Array.from(section.querySelectorAll('sticky-add-to-cart'))
            .filter(matchesProduct)
            .forEach((sticky) => {
              this.applySyncedPrice(sticky.querySelector('.sticky-add-to-cart__price'), priceState);
            });

          Array.from(section.querySelectorAll('add-to-cart-component'))
            .filter((element) => !productId || !element.dataset.productId || element.dataset.productId === productId)
            .forEach((component) => {
              if (typeof component.updateDisplayedPrice === 'function') {
                component.updateDisplayedPrice(priceState);
              }
            });
        }
      }
    );

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target instanceof Element ? event.target : null;
      root?.querySelectorAll?.('quantity-breaks')?.forEach((el) => {
        if (typeof el.remountFromEditor === 'function') el.remountFromEditor();
      });
    });

    document.addEventListener('shopify:section:reorder', (event) => {
      const root = event.target instanceof Element ? event.target : null;
      root?.querySelectorAll?.('quantity-breaks')?.forEach((el) => {
        if (typeof el.remountFromEditor === 'function') el.remountFromEditor();
      });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target instanceof Element ? event.target : null;
      const breaks =
        root?.matches?.('quantity-breaks')
          ? root
          : root?.closest?.('quantity-breaks') || root?.querySelector?.('quantity-breaks');
      if (breaks && typeof breaks.remountFromEditor === 'function') {
        breaks.remountFromEditor();
      }
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const root = event.target instanceof Element ? event.target : null;
      const section = root?.closest?.('.shopify-section');
      section?.querySelectorAll?.('quantity-breaks')?.forEach((el) => {
        if (typeof el.remountFromEditor === 'function') el.remountFromEditor();
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["benefits"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('benefits-list')) {
    customElements.define(
      'benefits-list',
      class BenefitsList extends HTMLElement {
        connectedCallback() {
          this.classList.add('benefits--enhanced');
          this._floatedTip = null;
          this.handleClick = this.handleClick.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handleDocumentClick = this.handleDocumentClick.bind(this);
          this.handlePointerOver = this.handlePointerOver.bind(this);
          this.handlePointerOut = this.handlePointerOut.bind(this);
          this.handleFocusIn = this.handleFocusIn.bind(this);
          this.handleFocusOut = this.handleFocusOut.bind(this);
          this.handleReposition = this.handleReposition.bind(this);
          this.addEventListener('click', this.handleClick);
          this.addEventListener('keydown', this.handleKeydown);
          this.addEventListener('pointerover', this.handlePointerOver);
          this.addEventListener('pointerout', this.handlePointerOut);
          this.addEventListener('focusin', this.handleFocusIn);
          this.addEventListener('focusout', this.handleFocusOut);
          document.addEventListener('click', this.handleDocumentClick);
          window.addEventListener('resize', this.handleReposition);
          window.addEventListener('scroll', this.handleReposition, true);
        }

        disconnectedCallback() {
          this.closeAll();
          this.removeEventListener('click', this.handleClick);
          this.removeEventListener('keydown', this.handleKeydown);
          this.removeEventListener('pointerover', this.handlePointerOver);
          this.removeEventListener('pointerout', this.handlePointerOut);
          this.removeEventListener('focusin', this.handleFocusIn);
          this.removeEventListener('focusout', this.handleFocusOut);
          document.removeEventListener('click', this.handleDocumentClick);
          window.removeEventListener('resize', this.handleReposition);
          window.removeEventListener('scroll', this.handleReposition, true);
        }

        getPopup(tip) {
          return tip._popup || tip.querySelector('.benefits__tip-popup');
        }

        floatPopup(tip) {
          if (!tip) return;
          if (this._floatedTip && this._floatedTip !== tip) {
            this._floatedTip.classList.remove('is-open');
            this.restorePopup(this._floatedTip);
          }

          const popup = this.getPopup(tip);
          if (!popup) return;
          tip._popup = popup;

          if (!popup.classList.contains('benefits__tip-popup--floating')) {
            tip._placeholder = document.createComment('benefits-popup');
            popup.parentNode.insertBefore(tip._placeholder, popup);
            document.body.appendChild(popup);
            popup.classList.add('benefits__tip-popup--floating');
            const styles = getComputedStyle(this);
            popup.style.setProperty('--benefits-popup-bg', styles.getPropertyValue('--benefits-popup-bg'));
            popup.style.setProperty('--benefits-popup-text', styles.getPropertyValue('--benefits-popup-text'));
            popup.style.fontFamily = getComputedStyle(tip).fontFamily;
          }

          this._floatedTip = tip;
          this.positionPopup(tip);
        }

        restorePopup(tip) {
          if (!tip) return;
          const popup = tip._popup;
          if (!popup || !popup.classList.contains('benefits__tip-popup--floating')) {
            if (this._floatedTip === tip) this._floatedTip = null;
            return;
          }

          if (tip._placeholder && tip._placeholder.parentNode) {
            tip._placeholder.parentNode.insertBefore(popup, tip._placeholder);
            tip._placeholder.remove();
          }

          popup.classList.remove('benefits__tip-popup--floating');
          popup.style.left = '';
          popup.style.top = '';
          popup.style.transform = '';
          popup.style.fontFamily = '';
          if (this._floatedTip === tip) this._floatedTip = null;
        }

        positionPopup(tip) {
          const popup = this.getPopup(tip);
          if (!popup || !popup.classList.contains('benefits__tip-popup--floating')) return;

          const rect = tip.getBoundingClientRect();
          const gap = 10;
          const pad = 8;
          popup.style.left = `${rect.left + rect.width / 2}px`;
          popup.style.top = `${rect.top - gap}px`;
          popup.style.transform = 'translate(-50%, -100%)';

          const popRect = popup.getBoundingClientRect();
          let offsetX = 0;
          if (popRect.left < pad) offsetX = pad - popRect.left;
          else if (popRect.right > window.innerWidth - pad) offsetX = window.innerWidth - pad - popRect.right;

          if (popRect.top < pad) {
            popup.style.top = `${rect.bottom + gap}px`;
            popup.style.transform = `translate(calc(-50% + ${offsetX}px), 0)`;
            return;
          }

          popup.style.transform = `translate(calc(-50% + ${offsetX}px), -100%)`;
        }

        closeAll(except) {
          this.querySelectorAll('[data-benefits-tip]').forEach((tip) => {
            if (tip === except) return;
            tip.classList.remove('is-open');
            this.restorePopup(tip);
          });
        }

        handleClick(event) {
          const tip = event.target.closest('[data-benefits-tip]');
          if (!tip || !this.contains(tip)) return;
          event.preventDefault();
          event.stopPropagation();
          const willOpen = !tip.classList.contains('is-open');
          this.closeAll(tip);
          tip.classList.toggle('is-open', willOpen);
          if (willOpen) this.floatPopup(tip);
          else this.restorePopup(tip);
        }

        handleKeydown(event) {
          if (event.key === 'Escape') {
            this.closeAll();
            return;
          }
          if (event.key !== 'Enter' && event.key !== ' ') return;
          const tip = event.target.closest('[data-benefits-tip]');
          if (!tip || !this.contains(tip)) return;
          event.preventDefault();
          tip.click();
        }

        handlePointerOver(event) {
          if (event.pointerType === 'touch') return;
          const tip = event.target.closest('[data-benefits-tip]');
          if (!tip || !this.contains(tip)) return;
          this.floatPopup(tip);
        }

        handlePointerOut(event) {
          const tip = event.target.closest('[data-benefits-tip]');
          if (!tip || !this.contains(tip)) return;
          const next = event.relatedTarget;
          if (next instanceof Node && tip.contains(next)) return;
          if (tip.classList.contains('is-open')) return;
          this.restorePopup(tip);
        }

        handleFocusIn(event) {
          const tip = event.target.closest('[data-benefits-tip]');
          if (!tip || !this.contains(tip)) return;
          this.floatPopup(tip);
        }

        handleFocusOut(event) {
          const tip = event.target.closest('[data-benefits-tip]');
          if (!tip || !this.contains(tip)) return;
          const next = event.relatedTarget;
          if (next instanceof Node && tip.contains(next)) return;
          if (tip.classList.contains('is-open')) return;
          this.restorePopup(tip);
        }

        handleDocumentClick(event) {
          if (!this.contains(event.target)) this.closeAll();
        }

        handleReposition() {
          if (this._floatedTip) this.positionPopup(this._floatedTip);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
